"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_cookie_1 = require("react-cookie");
const ui_1 = require("@phishtool/ui");
const analytics = __importStar(require("@phishtool/analytics"));
const styled_1 = require("./styled");
const paragraph_1 = require("~components/paragraph");
const CookieBanner = () => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 10);
    const [cookies, setCookie] = (0, react_cookie_1.useCookies)(['phishtool-cookies']);
    const hasCookie = !!cookies['phishtool-cookies'];
    const initialValues = {
        type: 'all',
    };
    return hasCookie ? null : ((0, jsx_runtime_1.jsxs)(styled_1.StyledCookieBannerWrapper, { children: [(0, jsx_runtime_1.jsx)(styled_1.StyledCookieBannerHeading, { children: "Cookies on PhishTool" }), (0, jsx_runtime_1.jsx)(paragraph_1.Paragraph, { spacer: "x3", children: "We use necessary cookies to make PhishTool work. We'd also like to set analytics cookies that help us make improvements by measuring how you use PhishTool." }), (0, jsx_runtime_1.jsx)(ui_1.Formik, { initialValues: initialValues, onSubmit: (values) => {
                    analytics.setOptOut(values.type === 'necessary');
                    setCookie('phishtool-cookies', values.type, {
                        expires,
                    });
                }, children: (props) => ((0, jsx_runtime_1.jsx)(ui_1.Form, { submitText: "Accept", submitTheme: "upgrade", formikProps: props, spacer: "x0", children: (0, jsx_runtime_1.jsx)(ui_1.Field, { type: "radio", name: "type", options: [
                            {
                                value: 'all',
                                label: 'Accept all cookies',
                            },
                            {
                                value: 'necessary',
                                label: 'Accept only necessary cookies',
                            },
                        ], formikProps: props }) })) })] }));
};
exports.default = CookieBanner;
